import "./operator-context-strip.css";

export type OperatorSourceClass = "synthetic" | "public-benchmark" | "hosted-poc";
export type OperatorConnection = "loopback" | "hosted";

const SOURCE_CLASS_LABEL: Record<OperatorSourceClass, string> = {
  synthetic: "Synthetic",
  "public-benchmark": "Public benchmark (intentionally vulnerable test data)",
  "hosted-poc": "Hosted PoC",
};

const CONNECTION_LABEL: Record<OperatorConnection, string> = {
  loopback: "Loopback",
  hosted: "Hosted",
};

function visibleFact(value: string | undefined): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "Unavailable";
}

export function OperatorContextStrip({
  tenantId,
  role,
  scanId,
  allScans = false,
  sourceClass,
  snapshotLabel,
  connection,
  staticOnly,
}: {
  tenantId: string;
  role: string;
  scanId?: string | undefined;
  allScans?: boolean | undefined;
  sourceClass: OperatorSourceClass;
  snapshotLabel?: string | undefined;
  connection: OperatorConnection;
  staticOnly: true;
}) {
  const scanLabel = allScans ? "All scans" : visibleFact(scanId);

  return (
    <section
      className={`operator-context-strip operator-context-strip--${sourceClass}`}
      data-testid="operator-context-strip"
      aria-label="Operator review context"
    >
      <span className="operator-context-strip__seal">
        {staticOnly ? "Static only" : "Unavailable"}
      </span>
      <dl className="operator-context-strip__fact">
        <dt>Source</dt>
        <dd>{SOURCE_CLASS_LABEL[sourceClass]}</dd>
      </dl>
      <dl className="operator-context-strip__fact">
        <dt>Scan</dt>
        <dd>{scanLabel}</dd>
      </dl>
      <dl className="operator-context-strip__fact">
        <dt>Tenant</dt>
        <dd>{visibleFact(tenantId)}</dd>
      </dl>
      <dl className="operator-context-strip__fact">
        <dt>Role</dt>
        <dd>{visibleFact(role)}</dd>
      </dl>
      <dl className="operator-context-strip__fact">
        <dt>Connection</dt>
        <dd>{CONNECTION_LABEL[connection]}</dd>
      </dl>
      {snapshotLabel ? (
        <dl className="operator-context-strip__fact">
          <dt>Snapshot</dt>
          <dd>{snapshotLabel}</dd>
        </dl>
      ) : null}
    </section>
  );
}
